import { ItemDefinitionType } from '../types/DropDownTypes';

type DropDownItem<T extends string | number> = {
  item: ItemDefinitionType<T>;
  isSelected: boolean;
  onClick: (item: ItemDefinitionType<T>) => void;
};

const DropDownItem = <T extends string | number>({
  item,
  isSelected,
  onClick,
}: DropDownItem<T>): JSX.Element => {
  return (
    <button
      className={`${
        isSelected ? 'bg-gray-lightest' : ''
      } flex w-full flex-row items-center rounded-md px-3 py-2 text-left text-base font-medium tracking-tight text-gray-darkest hover:bg-gray-lightest focus:outline-none`}
      onClick={() => onClick(item)}
    >
      {item.icon ? (
        <div className='mr-2'>{item.icon()}</div>
      ) : (
        <div
          className={` ${
            isSelected ? 'bg-green' : 'bg-gray'
          } mr-3 flex h-2 w-2 flex-shrink-0 rounded-full`}
        ></div>
      )}

      {item.label}
    </button>
  );
};

export default DropDownItem;
